import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import Pagination from '@components/Pagination'

import ProjectsTable from './ProjectsTable'

class ProjectsTab extends Component {
  static propTypes = {
    clientContactStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    props.clientContactStore.getProjects()
  }

  renderError (error) {
    if (error) return <Error />
  }

  renderLoader () {
    return <Spinner />
  }

  render () {
    const {
      getProjects,
      projects,
      projectCount,
      projectsPage,
      contact,
      projectsLoading,
      error
    } = this.props.clientContactStore
    const { fullName } = contact

    if (error) {
      return this.renderError(error)
    }
    if (projectsLoading) {
      return this.renderLoader()
    }
    return (
      <DocumentTitle title={`${fullName} - projects | Atheneum Partners`}>
        <div>
          {projects && projectCount ? (
            <div>
              <ProjectsTable projects={projects} />
              <Pagination
                total={projectCount}
                perPage={10}
                page={projectsPage}
                onChange={p => getProjects(p)}
              />
            </div>
          ) : (
            <Error label={'No projects match the current search parameters'} />
          )}
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('contactProjectsStore')(observer(ProjectsTab))
